import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { GlobalPlayer } from "@/components/GlobalPlayer";
import { VideoModal } from "@/components/VideoModal";
import Home from "@/pages/Home";
import ShowPage from "@/pages/ShowPage";
import EpisodePage from "@/pages/EpisodePage";
import PrivacyPage from "@/pages/PrivacyPage";
import ContactPage from "@/pages/ContactPage";
import AdvertisePage from "@/pages/AdvertisePage";
import PagesAdmin from "@/pages/admin/PagesAdmin";
import ShowsPage from "@/pages/ShowsPage";
import SearchPage from "@/pages/SearchPage";
import CategoryPage from "@/pages/CategoryPage";
import JoinPage from "@/pages/JoinPage";
import HostPage from "@/pages/HostPage";
import HostsPage from "@/pages/HostsPage";
import ApplicationsAdmin from "@/pages/admin/ApplicationsAdmin";
import HomepageAdmin from "@/pages/admin/HomepageAdmin";
import MenusAdmin from "@/pages/admin/MenusAdmin";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ShowsAdmin from "@/pages/admin/ShowsAdmin";
import EpisodesAdmin from "@/pages/admin/EpisodesAdmin";
import TeamAdmin from "@/pages/admin/TeamAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import ActivityAdmin from "@/pages/admin/ActivityAdmin";
import PublishingAdmin from "@/pages/admin/PublishingAdmin";
import ClubMapAdmin from "@/pages/admin/ClubMapAdmin";
import ReportsAdmin from "@/pages/admin/ReportsAdmin";
import TimecodesAdmin from "@/pages/admin/TimecodesAdmin";
import WordFinderAdmin from "@/pages/admin/WordFinderAdmin";
import PodcastFinderAdmin from "@/pages/admin/PodcastFinderAdmin";
import CleanerAdmin from "@/pages/admin/CleanerAdmin";
import InterviewAdmin from "@/pages/admin/InterviewAdmin";
import ArticlesAdmin from "@/pages/admin/ArticlesAdmin";
import ArticlePage, { ArticlesIndex } from "@/pages/ArticlePage";
import AuthorPage from "@/pages/AuthorPage";
import SurveyAdmin from "@/pages/admin/SurveyAdmin";
import SurveyPage from "@/pages/SurveyPage";
import ReviewPage from "@/pages/ReviewPage";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import { SurveyPopup } from "@/components/SurveyPopup";
import { LaunchGate } from "@/components/LaunchGate";
import PublishPage from "@/pages/PublishPage";
import MySubmissionsPage from "@/pages/MySubmissionsPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
        <PlayerProvider>
          <BrowserRouter>
            <ThemeProvider>
            <LaunchGate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shows" element={<ShowsPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/browse/:slug" element={<CategoryPage />} />
              <Route path="/join" element={<JoinPage />} />
              <Route path="/hosts" element={<HostsPage />} />
              <Route path="/hosts/:slug" element={<HostPage />} />
              <Route path="/shows/:slug" element={<ShowPage />} />
              <Route path="/episodes/:id" element={<EpisodePage />} />
              <Route path="/articles" element={<ArticlesIndex />} />
              <Route path="/articles/:slug" element={<ArticlePage />} />
              <Route path="/authors/:slug" element={<AuthorPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/advertise" element={<AdvertisePage />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/publish" element={<PublishPage />} />
              <Route path="/publish/submissions" element={<MySubmissionsPage />} />
              <Route path="/survey" element={<SurveyPage />} />
              <Route path="/review" element={<ReviewPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="shows" element={<ShowsAdmin />} />
                <Route path="episodes" element={<EpisodesAdmin />} />
                <Route path="team" element={<TeamAdmin />} />
                <Route path="applications" element={<ApplicationsAdmin />} />
                <Route path="publishing" element={<PublishingAdmin />} />
                <Route path="club-map" element={<ClubMapAdmin />} />
                <Route path="reports" element={<ReportsAdmin />} />
                <Route path="timecodes" element={<TimecodesAdmin />} />
                <Route path="wordfinder" element={<WordFinderAdmin />} />
                <Route path="podcast-finder" element={<PodcastFinderAdmin />} />
                <Route path="cleaner" element={<CleanerAdmin />} />
                <Route path="interview" element={<InterviewAdmin />} />
                <Route path="articles" element={<ArticlesAdmin />} />
                <Route path="survey" element={<SurveyAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="homepage" element={<HomepageAdmin />} />
                <Route path="menus" element={<MenusAdmin />} />
                <Route path="pages" element={<PagesAdmin />} />
                <Route path="settings" element={<SettingsAdmin />} />
                <Route path="activity" element={<ActivityAdmin />} />
              </Route>
            </Routes>
            <GlobalPlayer />
            <VideoModal />
            <SurveyPopup />
            </LaunchGate>
            </ThemeProvider>
          </BrowserRouter>
          <Toaster theme="dark" position="bottom-right" />
        </PlayerProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
